import { render, staticRenderFns } from "./CryptoTransfers.vue?vue&type=template&id=972e4fec"
import script from "./CryptoTransfers.vue?vue&type=script&lang=js"
export * from "./CryptoTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports